export default "__VITE_ASSET__0fe0604a__"